module.exports = __webpack_public_path__ + "static/media/down_arrow.101a2617.svg";